/**
 * Shared attribution-window caption helpers.
 *
 * Consumed by the analytics-v2 marketing widgets (FunnelWidget,
 * CampaignsWidget, ...) so a caption change (or a new attribution window
 * shipped by Meta) is a single-file edit instead of a widget-by-widget
 * update that risks divergence.
 *
 * Extracted from the widgets as part of CORE-1041.
 */

import type { AttributionWindow } from '@/types/api';

const ATTRIBUTION_CAPTIONS: Record<AttributionWindow, string> = {
  '7d_click_1d_view': '7-day click / 1-day view (matches Meta Ads Manager default)',
};

/**
 * Human-readable caption for an attribution-window token. Unknown values are
 * rendered as the raw token so operators can flag drift instead of seeing a
 * blank cell — better to surface an unexpected server value than silently
 * hide it. Add a Record entry when a new attribution window ships.
 */
export function attributionCaption(window: AttributionWindow): string {
  const known = ATTRIBUTION_CAPTIONS[window];
  if (known !== undefined) return known;
  return window;
}
